import React, {useState} from "react";
import {Row} from "antd";
import moment from "moment";
import Filters from "./Components/Filters";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import DataTable from "./Components/DataTable";

const QuickReactionCouriers = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [filters, setFilters] = useState({
        city: undefined,
        period: "choose",
        startDate: moment()
            .subtract(1, "d")
            .toDate(),
        endDate: moment()
            .add(3, "d")
            .toDate(),
        searchText: undefined
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftStore.listQuickReactionCourierList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            city: filters.city,
            period: filters.period,
            startDate: filters.startDate,
            endDate: filters.endDate,
            searchText: filters.searchText
        }),
        dependencies: [filters, currentPage, reloadData]
    });

    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row>
                <DataTable
                    loading={loading}
                    data={data?.result?.rows || []}
                    setData={setData}
                    dataCount={data?.result?.dataCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>
        </div>
    );
};

export {QuickReactionCouriers};
